import React from 'react';
import PropTypes from 'prop-types';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsLinkLabel } from './ps-link-label/PsLinkLabel';
import { PsRoutes } from '../../../shared/routing/Routes';

export const DocumentLabel = (
    {
        document,
    },
) => {
    const [to, setTo] = React.useState(undefined);

    React.useEffect(() => {
        if ( document ) {
            let route = undefined;
            const origin = document.origin();
            const routeParams = {};

            if ( origin.hasDocument() ) {
                routeParams.documentId = origin.documentId();
            }

            if ( origin.hasCompany() ) {
                if ( origin.isFromMyContractors() ) {
                    routeParams.contractorId = origin.companyId();
                    route = PsRoutes.MY_CONTRACTORS_DOCUMENTS_DETAIL;
                } else {
                    routeParams.outsourceId = origin.companyId();
                    route = PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL;
                }
            }

            if ( origin.hasWorker() ) {
                routeParams.workerId = origin.workerId();
                route = origin.isFromMyContractors()
                    ? PsRoutes.MY_CONTRACTORS_WORKERS_DOCUMENTS_DETAIL
                    : PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL;
            }

            if ( origin.hasMachine() ) {
                routeParams.machineId = origin.machineId();
                route = origin.isFromMyContractors()
                    ? PsRoutes.MY_CONTRACTORS_MACHINES_DOCUMENTS_DETAIL
                    : PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL;
            }

            const nextTo = RouterUtils.generateRoute(route, routeParams);
            const isWrong = nextTo.includes('undefined');

            if ( !isWrong ) {
                setTo(nextTo);
            }
        }
    }, [document]);

    if ( !document ) {
        return null;
    }

    const style = { backgroundColor: document.stateColor() };
    const documentName = document.name();

    return (
        <PsLinkLabel
            to={to}
            label={documentName}
            labelStyle={style}
        />
    );
};

DocumentLabel.propTypes = {
    document: PropTypes.object,
};

DocumentLabel.defaultProps = {
    document: null,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/components/DocumentLabel.jsx